import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  { q: 'How long does a tourist visa take to process?',
    a: 'Processing times vary by country. Schengen visas (Europe) take 15–30 days, UK and Canada 15–30 days, Australia 20–45 days, USA 30–60 days, and South-East Asian destinations like Singapore, Thailand, and Malaysia as fast as 3–7 days. Apply well in advance of your travel date.' },
  { q: 'What documents are required for a tourist visa?',
    a: 'Core documents include a valid passport (6+ months validity), recent photographs, 6-month bank statements, flight reservation, hotel booking, travel itinerary, financial proof (ITR, salary slips), employment/business proof, and travel insurance. Requirements vary by country — we provide a personalised checklist.' },
  { q: 'Can you assist with rejected or refused visa applications?',
    a: 'Yes. We specialise in refusal cases — we analyse the rejection reason, address application gaps, prepare a stronger cover letter, and guide you through the reapplication. We have helped many clients get approved after a prior refusal.' },
  { q: 'Do you provide travel insurance assistance?',
    a: 'Yes. Many countries (especially Schengen) require travel insurance with minimum €30,000 medical coverage. We help you choose the right plan that meets destination requirements and include it in your application.' },
  { q: 'Can you help with appointment bookings for visa applications?',
    a: 'Yes. We assist with booking slots at visa application centres and consulates, navigate booking systems, find earliest available slots, and ensure all prerequisites (DS-160, fee receipts, documents) are ready.' },
  { q: 'What is the difference between an eVisa, ETA, and tourist visa?',
    a: 'A Tourist Visa is a traditional stamp/sticker in your passport requiring embassy approval. An eVisa is applied and approved online — linked digitally to your passport. An ETA (Electronic Travel Authorization) is an automated pre-screening system for eligible nationalities. We assist with all three types.' },
  { q: 'What are your service fees?',
    a: 'Our fees are transparent and vary by country and service type. No hidden charges — you see a complete breakdown before we begin. Government visa fees and VFS charges are separate and paid directly. Contact us for a quote.' },
  { q: 'How can I track my visa application status?',
    a: 'After submission we provide your application reference number and guide you on tracking it via the embassy or VFS portal. Our team monitors timelines and alerts you to any updates. You can also message us on WhatsApp anytime.' },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="faq" className="sec">
      <div className="container">
        <div style={{ marginBottom: 40 }}>
          <p className="label"><i className="fas fa-circle-question"></i> FAQ</p>
          <h2 className="sec-title">Frequently Asked <span>Questions</span></h2>
          <div className="rule"></div>
        </div>

        <div className="faq-layout">
          <div className="faq-list">
            {faqs.map((f, i) => (
              <div className={`faq-item${open === i ? ' open' : ''}`} key={i}>
                <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                  <span className="faq-q-text">{f.q}</span>
                  <span className="faq-icon">
                    <i className={`fas fa-chevron-${open === i ? 'up' : 'down'}`}></i>
                  </span>
                </button>
                <div className={`faq-a${open === i ? ' open' : ''}`}>
                  <p>{f.a}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="faq-sidebar">
            <div className="faq-cta-card">
              <div className="faq-cta-icon"><i className="fas fa-headset"></i></div>
              <h4>Still have questions?</h4>
              <p>Our visa experts are available to answer your questions personally and quickly.</p>
              <div className="faq-cta-stack">
                <a href="https://wa.me/918287450060" target="_blank" rel="noopener noreferrer"
                  className="btn btn-wa">
                  <i className="fab fa-whatsapp"></i> Chat on WhatsApp
                </a>
                <button className="btn btn-teal" onClick={() => go('inquiry')}>
                  <i className="fas fa-paper-plane"></i> Submit Inquiry
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
